import React, { useState } from 'react';
// @ts-ignore
import { useTabIndex } from 'react-tabindex';
import styled from 'styled-components';
import { getColourFromColourTag } from '../../../helpers/colour';

type Props = {
  isSelected: boolean;
  colourCode: string;
  colourSwatch: string;
  colourName: string;
  onClick: () => void;
  colour_discount_code?: string;
  isHoneyComb?: boolean | undefined;
  disableTooltip?: boolean;
  // onMouseOver: () => void;
};

const StyledWrapper = styled.span<{
  isCurtain: boolean;
}>`
  margin: 0;
  position: relative;

  @media (min-width: 768px) {
    /* margin: 1rem 9px; */
    ${({ isCurtain }) => {
    if (isCurtain) {
      return `min-width: 30px !important;
        max-width: 30px !important;`;
    }
  }};
  min-width: 41px !important;
  max-width: 41px !important;
  }

  @media (max-width: 1700px) {
    min-width: calc(7.5% - 2.5px) !important;
    max-width: calc(7.5% - 2.5px) !important;
    margin-bottom: 2px;
  }

  @media (max-width: 767px) {
    margin-bottom: 2px;
    min-width: calc(14.5% - 2.5px) !important;
    max-width: calc(14.5% - 2.5px) !important;
  }
`;

const StyledColorHoverWrapper = styled.div<{
  isCurtain: boolean;
}>`
position: absolute;
bottom: 145px;
left:-22px;

@media (min-width: 768px) {
  bottom: auto;
  top: -85px;
}

@media (max-width: 1440px) {
  left: -22px;
}
`;

const StyledColorHoverInner = styled.div<{
}>` 
position: fixed;
width: 82px;
box-shadow: 0px 1px 3px #00000029;
border-radius:6px;
background: #FFF;
&:after{
  content: " ";
  position: absolute;
  right: 36px;
  border-top: 6px solid #fff;
  border-right: 6px solid transparent;
  border-left: 6px solid transparent;
  border-bottom: none;
}

@media (min-width: 768px) {
  width: 73px;

  &:after {
    right: 28px;
  }
}
`;

const StyledColorHoverImage = styled.span<{
  colourCode: string;
  colourSwatch: string;
}>`
margin: 0 auto;
width: 100%;
height: 82px;
display: block;
border-radius: 6px;
border: 1px solid #FFFFFF;
  ${({ colourCode, colourSwatch }) => {
    return colourSwatch !== ''
      ? `background-image: url(${colourSwatch});`
      : colourCode
        ? `background: ${colourCode} 0% 0% no-repeat padding-box;`
        : '';
  }};

  @media (min-width: 768px) {
    height: 60px;
  }
  
  @media (max-width: 767px) {
    display: none;
  }
`;

const StyledColorHoverName = styled.div<{
}>`
font-size: 10px;
padding: 2px 5px; 
text-align: center;
`;

const StyledColorWrapper = styled.span<{
  isSelected: boolean;
  colourCode: string;
  isCurtain: boolean;
  isHoneyComb: boolean;
}>`
  display: block;
  width: 60px;
  height: 60px;
  cursor: pointer;
  border-radius: 50%;
  background: transparent;
  margin: auto;

  * {
    transition: all 0.2s ease-out;
  }

  ${({ isSelected }) => {
    if (isSelected) {
      return `box-shadow: 0px 0px 5px 3px #00000029;`;
    }
  }};

  @media (min-width: 768px) {
    ${({ isCurtain, isHoneyComb }) => {
    if (isCurtain) {
      return `width: 30px;
        height: 30px;`;
    } else if (isHoneyComb) {
      return `width: 30px;
        height: 30px;`;
    } else {
      return `width: 30px;
        height: 30px;`
    }
  }};
  }

    @media (max-width: 767px) {
    ${({ isCurtain, isHoneyComb }) => {
    if (isCurtain) {
      return `width: 30px;
        height: 30px;`;
    } else if (isHoneyComb) {
      return `width: 30px;
        height: 30px;`;
    } else {
      return `width: 30px;
        height: 30px;`
    }
  }};
  }
`;

const StyledColorButton = styled.span<{
  isSelected: boolean;
  colourCode: string;
  colourSwatch: string;
}>`
  display: block;
  position: relative;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border-radius: 50%;
  transform: translate(4px, 4px);
  border: 1px solid #e8e8e8;

  @media (min-width: 768px) {
    width: calc(100% - 4px);
    height: calc(100% - 4px);
    transform: translate(2px, 2px);

    ${({ isSelected }) => {
    if (isSelected) {
      return `
        transform: translate(1px, 1px);
        width: calc(100% - 2px);
        height: calc(100% - 2px);`;
    }
  }};
  }

  ${({ isSelected }) => {
    if (isSelected) {
      return `
      transform: translate(2px, 2px);
      width: calc(100% - 4px);
      height: calc(100% - 4px);`;
    }
  }};

  ${({ colourCode, colourSwatch }) => {
    return colourSwatch !== ''
      ? `background-image: url(${colourSwatch});`
      : colourCode
        ? `background: ${colourCode} 0% 0% no-repeat padding-box;`
        : '';
  }};
`;

const ColourDiscountCode = styled('span')({
  "@media (min-width: 768px)": {
    position: "absolute",
    top: 0,
    height: "82px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    left: 0,
    right: 0,
    color: "#fff",
    fontSize: "25px",
    textAlign: "center",
  }
});

const SelectorColour = ({
  isSelected,
  colourCode,
  colourSwatch,
  colourName,
  onClick = () => { },
  colour_discount_code,
  isHoneyComb,
  disableTooltip
}: // onMouseOver = () => {},
  Props) => {
    
  const tabIndex: number = useTabIndex();
  const [isShown, setIsShown] = useState(false);

  return (
    <StyledWrapper className="keen-slider-selector__slide" isCurtain={window.location.href.includes("/curtain")}>
      <StyledColorWrapper
        colourCode={colourCode}
        tabIndex={tabIndex}
        isSelected={isSelected}
        onClick={onClick}
        isCurtain={window.location.href.includes("/curtain")}
        isHoneyComb={isHoneyComb ? isHoneyComb : false}
        onMouseEnter={() => !disableTooltip && setIsShown(true)}
        onMouseLeave={() => !disableTooltip && setIsShown(false)}
      >
        <StyledColorButton
          colourSwatch={colourSwatch}
          colourCode={colourCode}
          isSelected={isSelected}
        />
      </StyledColorWrapper>
      {!disableTooltip && isShown && (
        <StyledColorHoverWrapper isCurtain={window.location.href.includes("/curtain")}>
          <StyledColorHoverInner>
            <StyledColorHoverImage
              colourSwatch={colourSwatch}
              colourCode={colourCode}
            />
            {colour_discount_code && colour_discount_code !== "0%" && (
              <ColourDiscountCode>{colour_discount_code} off</ColourDiscountCode>
            )}
            <StyledColorHoverName>{getColourFromColourTag(colourName || '')}</StyledColorHoverName>
          </StyledColorHoverInner>
        </StyledColorHoverWrapper>
      )}
    </StyledWrapper>
  );
};

export default SelectorColour;